import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GetUserId } from '@core/utils';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/entities';
import { FilterQuery } from '@core/types';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RoomService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;
  private readonly _userId = GetUserId();

  find(pagination: Pagination, queryParams?: FilterQuery) {
    return this._http.get<any>(`${this._apiUrl}/getAllRooms?page=${pagination.page}&pageSize=${pagination.pageSize}`, { params: queryParams }).pipe(map((res: any) => res.result));
  }

  get(id: number) {
    return this._http.get<any>(`${this._apiUrl}/getRoomsById/${id}`).pipe(map((res: any) => res.result));
  }

  create(formData: any) {
    return this._http.post<any>(`${this._apiUrl}/createRoom`, formData);
  }

  update(id: number, formData: any) {
    return this._http.put<any>(`${this._apiUrl}/updateRooms/${id}`, formData);
  }

  delete(id: number) {
    return this._http.delete<any>(`${this._apiUrl}/deleteRooms/${id}`);
  }
}
